import { useEffect, useRef } from 'react';
import { leaveExamOnUnload } from '../assets/api/userActions';

/**
 * هنگام بستن تب مرورگر:
 * - اگر امکان ترک آزمون فعال باشد → ترک آزمون (broke_at)
 *
 * وقتی ترک غیرفعال است (leave=0) هیچ درخواستی روی unload ارسال نمی‌شود؛
 * رفرش صفحه هم beforeunload/pagehide را صدا می‌زند و اتمام خودکار باعث
 * پیام «قبلاً شرکت کرده‌اید» می‌شد.
 *
 * @param {boolean} leaveEnabled - آیا امکان ترک آزمون فعال است (examData?.quiz?.leave)
 * @param {number|string|null} attemptId - شناسه تلاش آزمون (examDataAttempt?.id)
 */
export function useLeaveExamOnTabClose(leaveEnabled, attemptId) {
    const ref = useRef({ leaveEnabled: false, attemptId: null });

    useEffect(() => {
        ref.current = { leaveEnabled: !!leaveEnabled, attemptId: attemptId ?? null };
    }, [leaveEnabled, attemptId]);

    useEffect(() => {
        const handler = () => {
            const { leaveEnabled: leave, attemptId: id } = ref.current;
            if (!id || !leave) {
                return;
            }
            leaveExamOnUnload(id);
        };

        window.addEventListener('pagehide', handler);
        return () => {
            window.removeEventListener('pagehide', handler);
        };
    }, []);
}
